import React, { Component } from "react"
import PropTypes from "prop-types"
import { Row, Col, Collapse } from "reactstrap"
import { Link, withRouter } from "react-router-dom"
import classname from "classnames"

//i18n
import { withTranslation } from "react-i18next"

import { getClientDetail } from "../../store/actions"
import { connect } from "react-redux"

class Navbar extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    let matchingMenuItem = null
    const ul = document.getElementById("navigation")
    const items = ul.getElementsByTagName("a")
    for (let i = 0; i < items.length; ++i) {
      if (this.props.location.pathname === items[i].pathname) {
        matchingMenuItem = items[i]
        break
      }
    }
    if (matchingMenuItem) {
      this.activateParentDropdown(matchingMenuItem)
    }

    const { onGetClientDetail } = this.props;
    onGetClientDetail(localStorage.getItem('userId'));
  }

  activateParentDropdown = item => {
    item.classList.add("active")
    const parent = item.parentElement
    if (parent) {
      parent.classList.add("active") // li
      const parent2 = parent.parentElement
      parent2.classList.add("active") // li
      const parent3 = parent2.parentElement
      if (parent3) {
        parent3.classList.add("active") // li
        const parent4 = parent3.parentElement
        if (parent4) {
          parent4.classList.add("active") // li
          const parent5 = parent4.parentElement
          if (parent5) {
            parent5.classList.add("active") // li
            const parent6 = parent5.parentElement
            if (parent6) {
              parent6.classList.add("active") // li
            }
          }
        }
      }
    }
    return false
  }
  isActivityActive = () => {
    const { pathname } = this.props.location;
    //console.log(pathname);
    return (
      pathname.startsWith("/messages") ||
      pathname.startsWith("/documents") ||
      pathname.startsWith("/appointment") 
      
    );
  };

    isBuyerActive = () => {
    const { pathname } = this.props.location;
    return (
      pathname.startsWith("/add-listing") ||
      pathname.startsWith("/compare-match")
    );
  };

   isProjectActive = () => {
    const { pathname } = this.props.location;
    return (
      pathname.startsWith("/project") ||
      pathname.startsWith("/my-interests") ||
       pathname.startsWith("/my-transection")

    );
  };

  render() {
    const { clientDetail } = this.props;    
    return (
      <React.Fragment>
        <div className="topnav">
          <div className="container-fluid">
            <nav
              className="navbar navbar-light navbar-expand-lg topnav-menu"
              id="navigation"
            >
              <Collapse
                isOpen={this.props.menuOpen}
                className="navbar-collapse"
                id="topnav-menu-content"
              >
                <ul className="navbar-nav">
                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none"
                     
                      to="/dashboard"
                    >
                      
                      {this.props.t(" Dashboard")} {this.props.menuOpen}
                     
                    </Link>
                    
                  </li>
                <li className={`nav-item dropdown ${this.isActivityActive() ? "active" : ""}`}>
                    <Link
                      className={`nav-link dropdown-toggle arrow-none ${
                        this.isActivityActive() ? "active" : ""
                      }`}
                      to="/messages"
                    >
                      
                      {this.props.t(" Activity")} {this.props.menuOpen}
                     
                    </Link>
                    
                  </li>
                <li className={`nav-item dropdown ${this.isBuyerActive() ? "active" : ""}`}>
                    <Link
                      className={`nav-link dropdown-toggle arrow-none ${
                        this.isBuyerActive() ? "active" : ""
                      }`}
                      to="/add-listing"
                    >
                   
                      
                      {this.props.t(" Buyer")} {this.props.menuOpen}
                     
                    </Link>
                    
                  </li>

                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none"
                     
                      to="/seller-showings"
                    >
                      
                      {this.props.t(" Seller")} {this.props.menuOpen}
                     
                    </Link>
                    
                  </li>
                 
                 <li className={`nav-item dropdown ${this.isProjectActive() ? "active" : ""}`}>
                 
                       <Link
                      className={`nav-link dropdown-toggle arrow-none ${
                        this.isProjectActive() ? "active" : ""
                      }`}
                      to="/project"
                    >
                      {this.props.t("PRE-CONSTRUCTION")}
                    </Link>
                   
                      
                    
                  </li>                 
                 
                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none"
                     
                      to="/deals"
                    >
                      
                      {this.props.t("Deals")} 
                     
                    </Link>
                    
                  </li>

                   <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none"
                     
                      to="/support"
                    >
                      
                      {this.props.t("Support")} 
                     
                    </Link>
                    
                  </li>
                
                </ul>
              </Collapse>
            </nav>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

Navbar.propTypes = {
  location: PropTypes.object,
  menuOpen: PropTypes.any,
  t: PropTypes.any,
  onGetClientDetail:PropTypes.func,
  clientDetail: PropTypes.object
}
const mapStateToProps = ({ Profile }) => (
  {
    clientDetail: Profile.clientDetail

  })
const mapDispatchToProps = dispatch => ({
  onGetClientDetail: clientId => dispatch(getClientDetail(clientId)),
});
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withTranslation()(Navbar)))
